// Utilities for money conversions and formatting (kopecks <-> rubles)

export function kopecksToRublesNumber(kopecks: number | bigint | null | undefined): number {
    if (typeof kopecks !== 'number' || Number.isNaN(kopecks))
        return 0;
    return kopecks / 100;
}

export function rublesToKopecksNumber(rubles: number | string | null | undefined): number {
    if (rubles === null || rubles === undefined || rubles === '')
        return 0;
    const parsed = typeof rubles === 'string' ? Number(rubles.replace(',', '.').replace(/[^0-9.\-]/g, '')) : rubles;
    if (typeof parsed !== 'number' || Number.isNaN(parsed))
        return 0;
    return Math.round(parsed * 100);
}

export function formatRubles(kopecks: number| bigint | null | undefined, options?: Intl.NumberFormatOptions): string {
    const rub = kopecksToRublesNumber(kopecks);
    const fmt = new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        ...options,
    });
    return fmt.format(rub);
}

export function formatRublesCompact(kopecks: number | null | undefined): string {
    const rub = kopecksToRublesNumber(kopecks);
    return new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rub);
}


